import { createReducer, on } from '@ngrx/store';
import { ImpersonationActions } from '@ps/auth-data-access';

import {
  SurveyListActions,
  SurveyListApiActions,
} from '../survey-list.actions';
import { INITIAL_CHILDREN_STATE } from '../../survey-state.constants';

export const childSurveysReducer = createReducer(
  INITIAL_CHILDREN_STATE,

  // New list query — child rows belong to a different result set; drop TTL cache.
  on(
    SurveyListActions.init,
    SurveyListActions.setFilters,
    SurveyListActions.setTab,
    SurveyListActions.setSort,
    () => INITIAL_CHILDREN_STATE,
  ),

  on(
    SurveyListApiActions.loadChildSurveysSuccess,
    (state, { parentId, surveys, cachedAt }) => {
      const { [parentId]: _clearedErr, ...childSurveyErrors } =
        state.childSurveyErrors;
      return {
        ...state,
        childSurveys: { ...state.childSurveys, [parentId]: surveys },
        childSurveysCachedAt: {
          ...state.childSurveysCachedAt,
          [parentId]: cachedAt,
        },
        childSurveyErrors,
      };
    },
  ),

  on(
    SurveyListApiActions.loadChildSurveysFailure,
    (state, { parentId, error }) => {
      const { [parentId]: _removedChildren, ...childSurveys } =
        state.childSurveys;
      return {
        ...state,
        childSurveys,
        childSurveysCachedAt: {
          ...state.childSurveysCachedAt,
          [parentId]: null,
        },
        childSurveyErrors: { ...state.childSurveyErrors, [parentId]: error },
      };
    },
  ),

  on(
    SurveyListApiActions.updateSurveyStatusSuccess,
    (state, { surveyId, status }) => ({
      ...state,
      childSurveys: Object.fromEntries(
        Object.entries(state.childSurveys).map(([parentId, children]) => [
          parentId,
          children.map((_status) =>
            _status.id === surveyId ? { ..._status, status } : _status,
          ),
        ]),
      ),
    }),
  ),

  on(ImpersonationActions.contextSettled, () => INITIAL_CHILDREN_STATE),
);
